import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { IUser } from '../core/interfaces/IUser';
import { AddEditFormComponent } from '../add-edit-form/add-edit-form.component';
import { AddEditModalGeneric } from '../../../ui/generics';

@Component({
    selector: 'app-add-edit-modal',
    templateUrl: './add-edit-modal.component.html',
    styleUrls: ['./add-edit-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditModalComponent extends AddEditModalGeneric<IUser, AddEditFormComponent> implements OnInit {

  @Input() override triggerTitle = 'Neuen Mitarbeiter erstellen';

  constructor(
    protected cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  rebuildTitle(): void {
    this.title = this.isNew
      ? 'Neuen Mitarbeiter erstellen'
      : `Mitarbeiter bearbeiten: ${this.object.firstName} ${this.object.lastName}`;
  }

  handleResetPass(): void {
    this.form.resetPassword();
    this.cdr.markForCheck();
  }

  regenerateBatch() {
    this.form.regenerateBatch();
    this.cdr.markForCheck();
  }
}
